export default __webpack_public_path__ + "static/logo-en-3c7f4420a68208330a2ade7ad6bd491f.svg";